import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
class Process extends Component {
	state={
		deguo:[
			{
				name:'驿渡线上直播',
				content:'数千欧美院校招生官同学在线直播分享',
			},
			{
				name:'境外接机住宿',
				content:'及时全面的行前指导，安生海外办公室提供支持',
			},
			{
				name:'留学签证申请',
				content:'模拟申请面试，模拟签证面试，详细签证指导',
			},
			{
				name:'海外院校申请',
				content:'历史数据支持，专业经验支撑，细致查校，精准定位',
			},
			{
				name:'美丞留学方案',
				content:'资深留学顾问量身定制一站式留学方案',
			},
			{
				name:'整体背景提升',
				content:'AmMentor外籍导师提升语言，模拟面试，修改文书，学术背景提升',
			},
			{
				name:'文书创作润色',
				content:'头脑风暴，挖掘亮点，英文原创，外籍校稿',
			},
			{
				name:'语言培训强化',
				content:'安生外国语学校出国语言考试培训',
			},
		],
		faguo:[
			{
				name:'咨询阶段',
				content:`<div><span>●</span>根据客户留学意向匹配相应的顾问老师，提供一对一咨询</div>
								 <div><span>●</span>介绍美丞留学服务内容和服务理念</div>
								 <div><span>●</span>初步了解学生的学习情况和搜集申请信息</div>
								 <div><span>●</span>提供标准化考试、选校、时间规划等专业咨询服务</div>
								 <div><span>●</span>制定背景提升方案，推荐实习机会</div>
								 <div><span>●</span>介绍海外教育和文化，特别是院校申请的情况</div>`,
			},
			{
				name:'选校阶段',
				content:`<div><span>●</span>制定考试时间表及建议分数目标</div>
								 <div><span>●</span>根据客户情况提供初步选校名单</div>
								 <div><span>●</span>提供客户院校招生信息及相关数据库</div>
								 <div><span>●</span>与客户共同确认最后申请院校和专业</div>
								 <div><span>●</span>指导客户提供申请材料，如成绩单、资金证明、信用卡等信息</div>
								 <div><span>●</span>协助客户成绩单、学位证、毕业证、在读证明等资料翻译</div>
								 <div><span>●</span>收集并核对客户转交的申请材料</div>`,
			},
			{
				name:'院校申请阶段',
				content:`<div><span>●</span>指导客户文书写作</div>
								 <div><span>●</span>与客户沟通文书素材及选材问题</div>
								 <div><span>●</span>指导文书修改和润色</div>
								 <div><span>●</span>网申填写、审核与提交</div>
								 <div><span>●</span>相关申请材料翻译、寄送申请材料</div>
								 <div><span>●</span>负责标准化考试送分</div>`,
			},
			{
				name:'院校申请跟踪阶段',
				content:`<div><span>●</span>日常院校状态查询和邮件回复</div>
								 <div><span>●</span>按照院校要求补寄申请材料</div>
								 <div><span>●</span>跟进申请状态</div>
								 <div><span>●</span>指导安排面试</div>
								 <div><span>●</span>确定所有院校最后录取结果</div>`,
			},
			{
				name:'签证培训阶段',
				content:`<div><span>●</span>预约签证面谈时间</div>
								 <div><span>●</span>签证材料指导和相关材料翻译、签证表格填写等</div>
								 <div><span>●</span>提供签证培训，包括签证要求、考核要点、签证程序、模拟面试等</div>`,
			},
			{
				name:'离境服务阶段',
				content:`<div><span>●</span>协助安排院校住宿和接机</div>
								 <div><span>●</span>开展行前培训（行前物品准备、当地法律、文化习俗、学习技巧、海外理财等内容）</div>
								 <div><span>●</span>提供机票预订信息</div>
								 <div><span>●</span>离境后跟进与关怀服务</div>
								 <div><span>●</span>推荐当地实习公司</div>
								 <div><span>●</span>提供毕业回国就业信息</div>`,
			},
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/process.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>美丞留学增值服务&全方位发展留学闭环</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.deguo.map((item,index)=>{
									return (
										<div className={'mingxiaoItem process'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>美丞留学服务内容及流程</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.faguo.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText processText'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Process